<script setup lang="ts">
import { ref } from 'vue'
import { breakpointsTailwind, onClickOutside } from '@vueuse/core'
import { bus as layoutBus } from '@/layouts/default.vue'

const breakpoints = useBreakpoints(breakpointsTailwind)
const isMobile = breakpoints.smaller('md')

const el = ref()
onClickOutside(el, closeOverlay)

function closeOverlay() {
  layoutBus.emit('toggle-cashOut')
}
</script>

<template>
  <div absolute :class="isMobile ? 'flex items-end bg-black bg-opacity-50' : ''" top-0 right-0 z-11 h-full>
    <div
      ref="el" p-4 bg-white :class="isMobile ? 'w-full rounded-tl-5 rounded-tr-5' : 'w-90 shadow-xl b-1'" overflow-y-auto :style="{
        height: isMobile ? `calc(100vh - ${MOBILE_HEADER_HEIGHT}px - 50px)` : `calc(100vh - ${HEADER_HEIGHT}px - 46px)`,
      }"
    >
      <div flex justify-between items-center>
        <Heading level="3">
          Cash Out
        </Heading>

        <AppButton variant="outline" w-8 h-8 @click="layoutBus.emit('toggle-cashOut')">
          <div i-mdi:window-close />
        </AppButton>
      </div>

      <div w-full mt-5>
        <Text variant="normal">
          Creators can cash out their earnings every 7 days as long as
          they have a balance of at least $10 in their account. Snack
          Prompt charges a fee of X per transaction.
        </Text>
      </div>

      <div b-1 rounded-4 flex p-4 flex-col gap-y-2 mt-5>
        <div flex justify-between w-full>
          <Text>Available for Cashout</Text>
          <Text bold>
            $ 242.20
          </Text>
        </div>

        <div flex justify-between w-full>
          <Text>Platform fee</Text>
          <Text bold>
            $ 24.20
          </Text>
        </div>

        <div flex justify-between w-full>
          <Text>Transaction fees</Text>
          <Text bold>
            $ 0.24
          </Text>
        </div>

        <div flex justify-between w-full mt-2>
          <Text bold>
            Total withdrawn
          </Text>
          <Text bold>
            $ 217.76
          </Text>
        </div>
      </div>

      <div mt-5>
        <Heading level="5" mb-2>
          Withdraw method
        </Heading>
        <AppTabs :default-tab="0" :border="1">
          <AppTab name="paypal">
            <form action="" mt-5>
              <div w-full>
                <FormInput placeholder="johndoe@gmail.com">
                  <template #label>
                    <div flex items-center gap-1>
                      <Text variant="normal">
                        Your PayPal Email Address
                      </Text>
                    </div>
                  </template>
                </FormInput>
              </div>

              <div w-full mt-3>
                <FormInput placeholder="$ XX">
                  <template #label>
                    <div flex items-center gap-1>
                      <Text variant="normal">
                        Amount to withdraw
                      </Text>
                    </div>
                  </template>
                </FormInput>
              </div>

              <AppButton w-full py-3 mt-5>
                Withdraw
              </AppButton>
            </form>
          </AppTab>

          <template #tab-paypal>
            <div flex items-center w-full justify-center>
              <div i-mdi:paypal />
              <Text px-4 py="6px" variant="normal">
                PayPal
              </Text>
            </div>
          </template>

          <AppTab name="bank">
            <Text>None</Text>
          </AppTab>
          <template #tab-bank>
            <Text px-4 py="6px" variant="small">
              Bank Transfer SOON
            </Text>
          </template>
        </AppTabs>
      </div>
    </div>
  </div>
</template>
